import { render } from "./ModalView.vue?vue&type=template&id=c024ff2e&scoped=true"
import script from "./ModalView.vue?vue&type=script&lang=js"
export * from "./ModalView.vue?vue&type=script&lang=js"

import "./ModalView.vue?vue&type=style&index=0&id=c024ff2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c024ff2e"]])

export default __exports__